export default class Carline {
  code: number | null = null;
  description: string | null = null;
  image: string | null = null;
}
